import React from 'react';
import { Text } from '@radix-ui/themes';
import roleplayIcon from '../../../../assets/images/roleplay.png';
import xCircleIcon from '../../../../assets/images/XCircle.png'; // Adjust path as needed

const RpRandomlySelected = ({ name, onClose, glmMode }) => {
  return (
    <div className="absolute z-[999] bottom-[1vh] mx-[4vw]">
      <div className="bg-[rgba(67,160,71,0.8)] p-[4vw] pb-0 rounded-[2vw] rounded-b-none self-start">
        <img
          src={roleplayIcon}
          alt="Roleplay"
          className="h-[8vw] w-[8vw] object-contain"
        />
      </div>
      <div className="w-[92vw] bg-[rgba(67,160,71,0.8)] px-[4vw] py-[3vh] rounded-[4vw] rounded-tl-none flex items-center">
        {glmMode === 'leader_system_select' && (
          <Text
            as="span"
            size="4"
            className="text-white font-[Lato-Regular] flex-1"
          >
            Viliyo has randomly selected {name} as your Group Leader!
          </Text>
        )}
        {glmMode === 'leader_each_select' && (
          <Text
            as="span"
            size="4"
            className="text-white font-[Lato-Regular] flex-1"
          >
            You have nominated and selected {name} as your Group Leader!
          </Text>
        )}
        {glmMode === 'leader_trainer_select' && (
          <Text
            as="span"
            size="4"
            className="text-white font-[Lato-Regular] flex-1"
          >
            Trainer has selected {name} as your Group Leader!
          </Text>
        )}
        <button onClick={onClose}>
          <img
            src={xCircleIcon}
            alt="Close"
            className="h-[8vw] w-[8vw] object-contain"
          />
        </button>
      </div>
    </div>
  );
};

export default RpRandomlySelected;